// Frontend mirror of the backend RBAC policy (internal/pkg/rbac/rbac.go).
// The backend is the source of truth and enforces these on write/admin routes;
// the UI uses the same rules to hide forbidden actions.

export type Role = 'admin' | 'editor' | 'viewer';
export type Scope = 'review:read' | 'review:write' | 'project:admin';

const policy: Record<Role, Scope[]> = {
    admin: ['review:read', 'review:write', 'project:admin'],
    editor: ['review:read', 'review:write'],
    viewer: ['review:read']
};

export const roleCan = (role: Role | null | undefined, scope: Scope): boolean =>
    !!role && (policy[role]?.includes(scope) ?? false);

/**
 * Legacy accessRights object derived from a role, so existing route/sidebar
 * gating (`accessRights[review_X] === 1 | 2`, `project_admin_space === 1`)
 * keeps working without change. 1 = write/editor, 2 = read/viewer, 3 = none.
 */
export const accessRightsFromRole = (role: Role | null | undefined) => {
    const reviewLevel = role === 'admin' || role === 'editor' ? 1 : 2;
    return {
        project_admin_space: role === 'admin' ? 1 : 3,
        review_1: reviewLevel,
        review_2: reviewLevel,
        review_3: reviewLevel,
        review_4: reviewLevel
    };
};
